module.exports = {
  title: 'Animated Stacked FlatList made with Reanimated',
  author: 'Enzo Manuel Mangano',
  date: '2024-05-01',
  slug: 'stacked-list',
  tags: ['reanimated'],
};
